import {ChangeDetectionStrategy,afterNextRender,Component,effect,inject,Injector} from '@angular/core';
import {NavigationEnd,Router} from '@angular/router';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {filter} from 'rxjs';
import {MATERIAL_IMPORTS} from './shared/material-imports';
import {COMMON_IMPORTS} from './shared/common-imports';
import {HeaderComponent} from './misc/components/header/header';
import {DrawerComponent} from './misc/components/drawer/drawer';
import {AppService} from './app.service';
import {SwUpdateService} from './common/sw-update.service';
import {DOCUMENT,ViewportScroller} from '@angular/common';
import {Meta,Title} from '@angular/platform-browser';
import {FooterComponent} from './misc/components/footer/footer';
import {CookieConsentComponent} from './misc/components/cookie-consent/cookie-consent';
import {LocalStorageService} from 'ngx-webstorage';
import {ConsentService} from './common/consent/consent.service';
import {environment} from '../environments/environment';

@Component({
	selector:'app-root',
	changeDetection:ChangeDetectionStrategy.OnPush,
	imports:[
		...MATERIAL_IMPORTS,
		...COMMON_IMPORTS,
		HeaderComponent,
		DrawerComponent,
		FooterComponent,
		CookieConsentComponent
	],
	templateUrl:'./app.html',
	styleUrl:'./app.scss'
})
export class App{
	private injector=inject(Injector);
	private viewportScroller=inject(ViewportScroller);
	private localStorageService=inject(LocalStorageService);
	private readonly consentService=inject(ConsentService);
	private document=inject(DOCUMENT);
	appService=inject(AppService);
	private router=inject(Router);
	private title=inject(Title);
	private meta=inject(Meta);
	private swUpdateService=inject(SwUpdateService);

	constructor(){
		const {title,meta}=this;
		title.setTitle($localize`:@@app-title|App default page title:Bendita`);
		meta.updateTag({content:$localize`:@@app-og-title|App default og title:Bendita`},'property="og:title"');
		this.router.events.pipe(
			filter((event):event is NavigationEnd=>event instanceof NavigationEnd),
			takeUntilDestroyed()
		).subscribe((event)=>this.appService.updateSeoUrls(event.urlAfterRedirects));
		meta.updateTag({content:$localize`:@@seo-description-default|Default SEO description:Plantas & Semillas Abierto las 24 horas`},'name="description"');
		meta.updateTag({content:$localize`:@@seo-description-default|Default SEO description:Plantas & Semillas Abierto las 24 horas`},'property="og:description"');
		meta.updateTag({content:$localize`:@@seo-description-default|Default SEO description:Plantas & Semillas Abierto las 24 horas`},'property="og:image:alt"');
		meta.updateTag({content:$localize`:@@seo-keywords-default|Default SEO keywords:bendita, grow, shop, semillas, plantas`},'name="keywords"');
		meta.updateTag({content:`${environment.siteUrl}/icons/icon-512x512.png`},'property="og:image"');

		afterNextRender(async()=>{
			this.viewportScroller.scrollToPosition([0,0]);
			if(this.document.defaultView){
				this.swUpdateService.initialize();
			}

			effect(()=>{
				const theme=this.appService.theme();
				this.document.documentElement.classList.remove('app-dark-theme');
				this.document.documentElement.classList.remove('app-light-theme');
				if(theme) this.document.documentElement.classList.add(theme);
				if(theme && this.consentService.preferences()) this.localStorageService.store('theme-id',theme);
				else this.localStorageService.clear('theme-id');
			},{injector:this.injector});
		});
	}

}
